import React from "react";
import { View, Text, StyleSheet, Image } from "react-native-web";
import logo from "../logo.png";

const Header = ({ text, logoImage }) => (
	<View style={styles.container}>
		<Image source={logoImage || logo} style={styles.apollo} />
		<View>
			<Text style={styles.text}>{text || "Suggestify"}</Text>
            {/* <Text style={styles.smallText}>{"Complete the survey"}</Text> */}
		</View>
	</View>
);

const styles = StyleSheet.create({
	container: {
		//justifyContent: "space-between",
		alignItems: "center",
		flexDirection: "row",
		padding: 10,
		width: "100%",
		backgroundColor: "#F7FAFD",
		borderBottomWidth: 1,
		borderColor: "#E2E8EF",
	},
	text: {
		fontSize: 22,
		fontWeight: "600",
		color: "black",
		marginLeft: 10,
		fontFamily: "NunitoSans",
	},
    smallText: {
		fontSize: 12,
		fontWeight: "400",
		color: "black",
		marginLeft: 10,
		fontFamily: "NunitoSans",
	},
	apollo: {
		height: 50,
		width: 50,
		borderRadius: 5,
	},
	heart: {
		height: 60,
		width: 60,
	},
});

export default Header;
